import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/nextjs/app/(microsites)/nido-de-villanas-meme/context-manager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/nextjs/app/lib/registry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleTagManager"] */ "/app/app/nextjs/app/util/gtm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/nextjs/components/avatar.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/nextjs/components/smart-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/nextjs/context/ua-parser.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/nextjs/styles/global.ts");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
